import { defineComponent as _defineComponent } from 'vue'
import {ref, onBeforeUnmount} from 'vue';
import {useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'result',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const second = ref(10);

const interval = setInterval(() => {
	second.value--;
	if (second.value < 1) {
		clearInterval(interval);
        go_default_page();
	}
}, 1000);

function go_default_page() {
    router.push('/media-list');
}

onBeforeUnmount(() => {
	clearInterval(interval);
});

const __returned__ = { router, second, interval, go_default_page }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})